import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import ItemEventoUser from "./User/ItemEventoUser";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import "./CSS/eventos.css";
const MySwal = withReactContent(Swal);

function Eventos() {
  const navigate = useNavigate();
  //configurar useState
  const [eventos, setEventos] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [eventosInactivos, setEventosInactivos] = useState([]);

  //referenciar la DB
  const eventosList = collection(db, "EVENTOS");
  //funcion para mostrar la lista de eventos
  const getEventos = async () => {
    const data = await getDocs(eventosList);
    setEventos(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    console.log(eventos);
  };
  //Funcion para eliminar evento
  const deleteEvento = async (id) => {
    const evento = doc(db, "EVENTOS", id);
    await deleteDoc(evento);
    getEventos();
  };
  //Funcion para editar evento
  const editEvento = async (id) => {
    //
    /*const evento = doc(db, "CUPONES", id);
    await deleteDoc(evento);
    getEventos();*/
  };

  //Alert eliminar evento
  const confirmDelete = (id) => {
    console.log("el id es = " + id);
    MySwal.fire({
      title: "Eliminar evento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar! ",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteEvento(id);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "El evento ha sido eliminado",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    });
  };

  const getActivos = async () => {
    const eventosFiltrados = query(
      eventosList,
      where("estado", "==", "Activo")
    );
    const data = await getDocs(eventosFiltrados);
    setEventos(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  const getInactivos = async () => {
    const eventosFiltrados = query(
      eventosList,
      where("estado", "==", "Inactivo")
    );
    const data = await getDocs(eventosFiltrados);
    setEventosInactivos(
      data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
    setDatosCargados(true);
  };

  //cerrar eventos
  const cerrar = () => {
    navigate("../panelAdmin");
  };
  //uso de useEffect
  useEffect(() => {
    getActivos();
    getInactivos();
  }, []);


  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="eventos">
      <NavBar
        titulo="Eventos"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
      ></NavBar>
    
    </div>
  );
}
export default Eventos;
